import cn from "clsx";
import { Skeleton } from "@crehana/ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LearnAcademyPanelHeaderSkeleton = function LearnAcademyPanelHeaderSkeleton(_ref) {
  var isDark = _ref.isDark,
    innerBackgroundColor = _ref.innerBackgroundColor,
    className = _ref.className;
  return /*#__PURE__*/_jsx(Skeleton, {
    className: cn('p-16 rounded-5', className),
    isDark: isDark,
    children: /*#__PURE__*/_jsx("div", {
      className: "flex flex-col sm:flex-row",
      children: /*#__PURE__*/_jsx("div", {
        className: "flex w-full",
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex items-center w-full sm:block",
          children: [/*#__PURE__*/_jsx(Skeleton, {
            className: cn('w-5/12 h-20 sm:h-24 rounded-5 mb-12', innerBackgroundColor)
          }), /*#__PURE__*/_jsx("div", {
            className: "flex",
            children: Array.from({
              length: 3
            }).map(function (_, i) {
              return /*#__PURE__*/_jsx(Skeleton, {
                className: cn('mr-16 w-212 h-80 rounded-5 flex-shrink-0', innerBackgroundColor)
              }, i.toString());
            })
          })]
        })
      })
    })
  });
};
export default LearnAcademyPanelHeaderSkeleton;